import React, { useCallback, useEffect, useState } from "react";

interface AntibodyIconProps {
  readonly color: string;
  readonly size: number;
  readonly rotation: number;
}

const AntibodyIcon: React.FC<AntibodyIconProps> = React.memo(
  ({ color, size, rotation }: AntibodyIconProps) => {
    const viewBoxSize = 512;

    return (
      <svg
        className="antibody-group"
        height={size}
        viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}
        width={size}
        xmlns="http://www.w3.org/2000/svg"
        style={
          {
            "--size": `${size}px`,
            "fill": `var(--color-${color})`,
            "transform": `rotate(${rotation}deg)`,
          } as React.CSSProperties
        }
      >
        <path d="M501.3 322.1c1.4 4.3-.8 9.2-5.3 10.8-4.3 1.6-9.2-.8-10.8-5.1L454 238.7c0-.1 0-.3.1-.3h.3c-.2-.3-.2-.6-.1-.8l14.6-60.5c1.1-4.5 5.7-7.4 10.1-6.2 4.5 1.1 7.4 5.7 6.2 10.1l-13.9 57.3c.6.7 1 1.5 1.4 2.4l28.6 81.3zm-.3-141.7c-4.5-1.2-9.1 1.7-10.1 6.2l-9.9 40.8c-1.2 4.5 1.7 9.1 6.2 10.1 4.5 1.2 9.1-1.7 10.1-6.2l9.9-40.8c1.2-4.5-1.7-9.1-6.2-10.1zm-60.8 62.9v-.2c.1 0-49.9-38.7-49.9-38.7-3.7-2.9-8.9-2.2-11.8 1.4-2.9 3.7-2.2 8.9 1.4 11.8l46 35.7 29.7 84.6c1.6 4.5 6.3 6.7 10.8 5.3 4.3-1.6 6.7-6.3 5.1-10.8l-31.3-89.2zm-27.8 8.1l-33.2-25.7c-3.7-2.9-8.9-2.2-11.8 1.4-2.9 3.7-2.2 8.9 1.4 11.8l33.2 25.7c3.7 2.9 8.9 2.2 11.8-1.4 2.9-3.7 2.2-8.9-1.4-11.8zm-33.6 131.2c-.3-.9-.8-1.7-1.4-2.4l13.7-57.3c1.2-4.5-1.7-9.1-6.2-10.1-4.5-1.2-9.1 1.7-10.1 6.2l-14.6 60.5c0 .2 0 .5.2.7h-.2c-.1 0-.1.2-.1.3l31.2 89.1c1.6 4.3 6.4 6.7 10.8 5.1 4.3-1.6 6.7-6.4 5.3-10.8l-28.6-81.3zm28.2-60.4c-4.5-1.2-9.1 1.7-10.1 6.2l-9.9 40.8c-1.2 4.5 1.7 9.1 6.2 10.1 4.5 1.2 9.1-1.6 10.1-6.2l9.9-40.8c1.2-4.5-1.7-9.1-6.2-10.1zM346.3 385h-.1l-49.9-38.6c-3.7-2.9-8.9-2.2-11.8 1.4-2.9 3.7-2.2 8.9 1.4 11.8l46.2 35.8 29.6 84.2c1.4 4.6 6.3 6.8 10.7 5.4 4.3-1.6 6.7-6.3 5.1-10.8l-31.2-89.3zm-27.9 8.3l-33.2-25.7c-3.7-2.9-8.9-2.2-11.8 1.4-2.9 3.7-2.2 8.9 1.4 11.8l33.2 25.7c3.7 2.9 8.9 2.2 11.8-1.4 2.9-3.7 2.2-8.9-1.4-11.8zM89.3 177.9l34.9 47.7c2.8 3.8 8 4.6 11.8 1.8 3.8-2.8 4.6-8 1.8-11.8L101 165.3c-.2-.2-.5-.3-.7-.3v-.2-.3L12.1 131c-4.3-1.7-9.2.5-10.9 4.9-1.6 4.3.7 9.2 4.9 10.8l80.5 30.7c.9.4 1.8.5 2.7.6zm27.3 48.3l-24.9-33.8c-2.8-3.8-8-4.6-11.8-1.8-3.8 2.8-4.6 8.2-1.8 11.8l24.9 33.8c2.8 3.8 8 4.6 11.8 1.8 3.8-2.8 4.6-8 1.8-11.8zM17.3 117.5l88.4 33.7 61.7-13.2c4.6-.9 7.5-5.5 6.4-10-.9-4.6-5.5-7.5-10-6.4l-56.9 12-83.7-31.9c-4.3-1.7-9.2.5-10.9 4.9-1.7 4.3.5 9.2 4.9 10.9zm100.3 7l41.1-8.8c4.6-.9 7.5-5.5 6.4-10-.9-4.6-5.5-7.5-10-6.4l-41.1 8.8c-4.6.9-7.5 5.4-6.4 10 .9 4.6 5.5 7.5 10 6.4zm84.5 301.7c4.5-1.2 7.2-5.8 6.2-10.3-1.2-4.5-5.8-7.2-10.3-6.2l-60.4 14.9c-.3 0-.4.2-.6.4h-.1c0-.2-.1-.2-.3 0L72 493.8c-3.2 3.4-3 8.8.4 12 3.4 3.2 8.7 3 12-.4l58.9-62.8c.6-.7 1.1-1.4 1.5-2.2l57.2-14.1zm-2.2 7.4l-40.8 10c-4.5 1.2-7.2 5.8-6.2 10.3 1.2 4.5 5.8 7.2 10.3 6.2l40.8-10c4.5-1.2 7.2-5.8 6.2-10.3-1.2-4.5-5.8-7.2-10.3-6.2zm-73.7-18.8l11.3-62c.8-4.6-2.2-8.9-6.8-9.9-4.6-.8-8.9 2.2-9.9 6.8l-10.3 57.2-61.3 65.3c-3.2 3.4-3 8.7.4 12 3.4 3.2 8.7 3 12-.4l64.7-68.9h-.1zM97 349.5l-7.5 41.3c-.8 4.6 2.2 8.9 6.8 9.9 4.6.8 8.9-2.2 9.9-6.8l7.5-41.3c.8-4.6-2.2-8.9-6.8-9.9-4.6-.8-8.9 2.2-9.9 6.8zM320 89c.2.6.6 1.1.9 1.6l-10 49.8c-.8 3.9 1.7 7.6 5.5 8.4h.3c3.9.8 7.6-1.7 8.4-5.5l10.5-52.2c0-.2 0-.5-.3-.6l.4-.2c.1 0 .1-.1.1-.3l-29.7-75c-1.4-3.6-5.5-5.4-9.2-3.9h-.3c-3.7 1.6-5.5 5.7-3.8 9.3l27.1 68.5zm-22.5 52.5h.3c3.9.8 7.6-1.7 8.4-5.5l7.1-35.4c.8-3.9-1.7-7.6-5.5-8.4h-.3c-3.9-.8-7.6 1.7-8.4 5.5l-7.1 35.4c-.8 3.9 1.7 7.6 5.5 8.4zm49.8-55.9c0 .1 43.9 31.4 43.9 31.4 3.2 2.2 7.6 1.6 9.9-1.7h.1c2.2-3.3 1.6-7.8-1.7-10l-40.2-28.7-28.2-71.3c-1.4-3.7-5.7-5.5-9.2-4.1h-.3c-3.7 1.6-5.4 5.7-3.9 9.3l29.7 75zm23.6-7.9l29.3 20.9c3.2 2.2 7.6 1.6 9.9-1.7h.1c2.2-3.3 1.6-7.8-1.7-10L379.2 66c-3.2-2.2-7.6-1.4-9.9 1.7h-.1c-2.2 3.3-1.6 7.8 1.7 10zm-59.1 166.6c3.6-1.2 5.4-5 4.2-8.6-1.2-3.6-5-5.4-8.6-4.2l-47.2 16.2c-.2 0-.3.3-.4.5h-.1c-.1-.2-.3-.2-.3-.1l-46.7 59.3c-2.2 2.9-1.7 7.1 1.2 9.5 3 2.4 7.2 1.8 9.5-1.1l42.6-54.2c.5-.7.9-1.4 1.1-2.1l44.7-15.2zm-1.3 6.2l-31.8 10.9c-3.6 1.2-5.4 5-4.2 8.6 1.3 3.6 5.1 5.4 8.6 4.2l31.8-10.9c3.6-1.2 5.4-5 4.2-8.6-1.2-3.6-5-5.4-8.6-4.2zm-116.3 50.9c2.9 2.4 7.2 1.8 9.5-1.2l46.8-59.5h-.1l4.6-50.4c.4-3.7-2.4-7-6.1-7.4-3.7-.4-7 2.4-7.4 6.1l-4.2 46.5-44.3 56.3c-2.2 3-1.7 7.2 1.2 9.6zm31.4-69.9c3.7.4 7-2.4 7.4-6.1l3-33.4c.4-3.7-2.4-7-6.1-7.4-3.7-.4-7 2.4-7.4 6.1l-3 33.4c-.4 3.7 2.4 7 6.1 7.4z" />
      </svg>
    );
  },
);

// eslint-disable-next-line functional/immutable-data -- React.memo displayName pattern
AntibodyIcon.displayName = "AntibodyIcon";

interface AntibodyIconConfig {
  readonly color: string;
  readonly icon: string;
  readonly size: number;
}

const ANTIBODY_ICONS: readonly AntibodyIconConfig[] = [
  { color: "midnight-blue-400", icon: "top-left", size: 152 },
  { color: "electric-blue-700", icon: "top-right", size: 180 },
  { color: "ruby-red-900", icon: "bottom-left", size: 192 },
  { color: "lemon-yellow-400", icon: "bottom-right", size: 180 },
];

const AntibodiesContainer: React.FC = () => {
  const [rotations, setRotations] = useState<number[]>([]);

  useEffect(() => {
    setRotations(ANTIBODY_ICONS.map(() => Math.floor(Math.random() * 360)));
  }, []);

  const renderAntibodyIcon = useCallback(
    (item: AntibodyIconConfig, index: number) => (
      <li data-icon={item.icon} key={item.icon}>
        {/* eslint-disable-next-line security/detect-object-injection -- index from .map() callback, safe */}
        <AntibodyIcon color={item.color} rotation={rotations[index] ?? 0} size={item.size} />
      </li>
    ),
    [rotations],
  );

  return (
    <div className="antibodies">
      <ul className="antibody-group-list">
        {rotations.length > 0 && ANTIBODY_ICONS.map(renderAntibodyIcon)}
      </ul>
    </div>
  );
};

export default React.memo(AntibodiesContainer);
